import { ShiftManagementActions } from './ShiftManagementActions';

export class ShiftManagementEvents {
  category = 'Shift Management';
  action = new ShiftManagementActions();
}
